module.exports = __webpack_public_path__ + "img/bsd.d3576523.svg";